import { render, staticRenderFns } from "./BFormMultiselect.vue?vue&type=template&id=59f1fbf2"
import script from "./BFormMultiselect.vue?vue&type=script&lang=js"
export * from "./BFormMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports